import { useMutation, useQueryClient } from "@tanstack/react-query";

import TenantAPI from "../../../api/api/TenantAPI";

import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { newToastEvent } from "../../../utils/ToastUtil";
import { AppConfirm } from "../../../utils/PopupUtil";

const useDeleteModule = () => {
  const queryClient = useQueryClient();

  const deleteModule = useMutation({
    mutationFn: ({
      moduleAPIName,
      supportTargetCloudID,
    }: {
      moduleName: string;
      moduleAPIName: string;
      supportTargetCloudID: string | undefined;
      onSuccess?: () => void;
      onError?: () => void;
    }) => {
      return TenantAPI.deleteModule(moduleAPIName, supportTargetCloudID);
    },
    onSuccess: (data, { moduleName, onSuccess, supportTargetCloudID }) => {
      const newSchema = data.data.data.schema;

      if (supportTargetCloudID) {
        queryClient.invalidateQueries({
          queryKey: ["schema", supportTargetCloudID],
        });
      }

      callFunctionIfExists(onSuccess, newSchema);
      AppConfirm({
        title: `${moduleName} Successfully Deleted`,
        text: "The module has been successfully deleted.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "var(--primary)",
        showCancelButton: false,
      });
    },
    onError: (error, { onError }) => {
      callFunctionIfExists(onError);
      newToastEvent(
        "error",
        getErrorMessage(error, "An unknown error occurred. Please try again.")
      );
    },
  });

  return {
    deleteModule: deleteModule.mutate,
    deleteModuleLoading: deleteModule.isPending,
    deleteModuleError: deleteModule.error
      ? getErrorMessage(deleteModule.error)
      : null,
  };
};

export default useDeleteModule;
